import React, { useState } from "react";
import { useSearchParams, createSearchParams } from "react-router-dom";
import {
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  MenuItem,
  Checkbox,
  Typography,
  useTheme,
  Divider,
  CircularProgress,
  Grid,
  Tooltip,
} from "@mui/material";
import CustomTable from "../../../../../../../components/shared/CustomTable";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/system";
import AddIcon from "@mui/icons-material/Add";
import { ReactComponent as ColumnFilterIcon } from "../../../../../../../assets/colum-filter-icon.svg";
import CustomMenu from "../../../../../../../components/shared/CustomMenu";
import CustomButton from "../../../../../../../components/shared/CustomButton";
import { useEffect } from "react";
import {
  ExitToApp as ExitToAppIcon,
  ArrowDropDown as ArrowDropDownIcon,
  FilterAlt as FilterAltIcon,
  ArrowRightAlt as ArrowRightAltIcon,
  SyncAlt as SyncAltIcon,
} from "@mui/icons-material";
import DialogFilter from "./DialogFilter";
import { ReactComponent as NoImage } from "../../../../../../../assets/no-image.svg";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { getAllHubs } from "../../../../../../../api/hubs";
import { CSVLink } from "react-csv";
import ExportXlsExcel from "../../../../../../../components/ExportXlsExcel";
import { useDispatch } from "react-redux";
import {
  changeMasterHub,
  loadMasterHubPack,
} from "../../../../../../../store/hub/hirarkiHub";
import { CircleIcon } from "../../../../../../../assets/Icons";

const CustomTableCells = styled(TableCell)({
  color: "#000000",
  fontWeight: 500,
  fontSize: "0.75rem",
  textTransform: "capitalize",
});

const headCells = [
  {
    id: "number",
    numeric: false,
    disablePadding: false,
    title: "No",
    icon: false,
  },
  {
    id: "photo",
    numeric: false,
    disablePadding: false,
    title: "Photo",
    icon: false,
  },
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    title: "Name",
    icon: true,
    sortName: "name",
  },
  {
    id: "subsidiary",
    numeric: false,
    disablePadding: false,
    title: "Subsidiary",
  },
  {
    id: "pic",
    numeric: false,
    disablePadding: false,
    title: "PIC",
  },
  {
    id: "phoneNumber",
    numeric: false,
    disablePadding: false,
    title: "Phone Number",
  },
  {
    id: "sku",
    numeric: false,
    disablePadding: false,
    title: "SKU",
    icon: true,
    sortName: "sku",
  },
  {
    id: "cogs",
    numeric: false,
    disablePadding: false,
    title: "COGS(Rp)*",
    icon: true,
    sortName: "cogs",
  },
  {
    id: "address",
    numeric: false,
    disablePadding: false,
    title: "Address",
  },
];

const Table = ({
  setRowSelected,
  hubsData,
  rowPerPageTable,
  setRowPerPageTable,
  rowPerPageValues,
  currentPageTable,
  setCurrentPageTable,
  totalTableItems,
  setIsOpenMasterHub,
  setSubHubSelected,
  masterHubKeyword,
  setMasterHubKeyword,
  subsidiaryDatas,
  setFilterSubsidiaryArray,
  isLoadingMasterHub,
  sortTableMasterHub,
  setSortTableMasterHub,
  isSortAscMasterHub,
  setIsSortAscMasterHub,
}) => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const updatedSearchParams = createSearchParams(searchParams);

  const [openColumnFilter, setOpenColumnFilter] = useState(null);
  const isOpenColumnFilter = Boolean(openColumnFilter);

  const [columnArray, setColumnArray] = useState([]);
  const [selectedColumn, setSelectedColumn] = useState([]);

  const theme = useTheme();

  useEffect(() => {
    setColumnArray(headCells);
  }, []);

  const handleSelectedColumn = (id) => {
    if (selectedColumn.includes(id)) {
      setSelectedColumn([...selectedColumn].filter((value) => value !== id));
    } else {
      setSelectedColumn([...selectedColumn, id]);
    }
  };

  const isSelected = (name) => selectedColumn.indexOf(name) !== -1;

  useEffect(() => {
    setSelectedColumn(
      columnArray
        .slice(0, searchParams.get("s") || 6)
        .map((headCell) => headCell.id)
    );
  }, [columnArray, searchParams]);

  const [openExport, setOpenExport] = useState(null);
  const isOpenExport = Boolean(openExport);

  const [isOpenDialogFilter, setIsOpenDialogFilter] = useState(false);

  const [hubsToExport, setHubsToExport] = useState([]);

  useEffect(() => {
    const fetchMasterListTable = async () => {
      let params = {};
      params.page = 1;
      params.pageSize = totalTableItems;
      params.name = "asc";

      try {
        const {
          data: {
            data: { hubs },
          },
        } = await getAllHubs(params);

        const bodyTable = hubs.map(
          (
            { namaToko, subsidiary, picPhone, picName, SKU, COGS, alamat },
            index
          ) => ({
            number: index + 1,
            name: namaToko || "-",
            subsidiary: subsidiary || "-",
            pic: picName || "-",
            phoneNumber: picPhone || "-",
            sku: SKU || "-",
            cogs: COGS || "-",
            address: alamat || "-",
          })
        );
        setHubsToExport(bodyTable);
      } catch (err) {
        console.error(err);
        setHubsToExport([]);
      }
    };

    if (hubsData?.length) {
      if (openExport) {
        if (hubsToExport?.length === 0) {
          fetchMasterListTable();
        }
      }
    }
  }, [hubsData, hubsToExport, openExport, totalTableItems]);

  const tempColumns = [...headCells];

  const columnWithoutPhoto = tempColumns.splice(1, 1);

  const downloadPdf = () => {
    const doc = new jsPDF();
    doc.text("Table Master Hub", 20, 10);
    doc.autoTable({
      theme: "grid",
      columns: tempColumns.map((col) => ({
        ...col,
        dataKey: col.id,
      })),
      body: hubsToExport,
    });
    doc.save("table.pdf");
    setOpenExport(null);
  };

  const [autocompleteFilter, setAutocompleteFilter] = useState({
    isSubsidiaryFull: false,
    isSubsidiaryOpen: false,
  });
  const [subsidiaryFilterValue, setSubsidiaryFilterValue] = useState([]);

  const allData = [{ name: "All" }];

  const handleSaveFilter = () => {
    const subsidiaryChoose = [];

    subsidiaryFilterValue.map(({ id }) => subsidiaryChoose.push(id));
    setFilterSubsidiaryArray(subsidiaryChoose);
    setIsOpenDialogFilter(false);
  };

  const handleResetFilter = () => {
    setSubsidiaryFilterValue([]);
    setAutocompleteFilter({
      ...autocompleteFilter,
      isSubsidiaryFull: false,
      isSubsidiaryOpen: false,
    });
  };

  const toolbar = (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        flexDirection: "row-reverse",
        alignItems: "center",
      }}
    >
      <CustomButton
        sx={{
          bgcolor: "#51B15C",
          color: "#ffffff",
          borderRadius: "8px",
          "&:hover": {
            bgcolor: "#51B15C",
            color: "#ffffff",
          },
          fontSize: "0.875rem",
          px: 2,
        }}
        startIcon={<AddIcon sx={{ width: "14px" }} />}
        onClick={() => {
          setIsOpenMasterHub(true);
        }}
      >
        Add
      </CustomButton>
      <IconButton
        sx={{
          border: "1.5px solid #51B15C",
          borderRadius: "8px",
          p: 1,
        }}
        onClick={(e) => setOpenColumnFilter(e.currentTarget)}
        aria-haspopup="true"
      >
        <ColumnFilterIcon fill="#51B15C" />
      </IconButton>
      <CustomMenu
        open={isOpenColumnFilter}
        openMenu={openColumnFilter}
        setOpenMenu={setOpenColumnFilter}
        sx={{
          ".MuiMenuItem-root": {
            paddingLeft: 0,
            paddingRight: "20px",
            paddingTop: 0,
            paddingBottom: 0,
            borderRadius: "8px",
          },
        }}
      >
        <Box
          sx={{ display: "flex", justifyContent: "space-between", p: "12px" }}
        >
          <Typography sx={{ fontWeight: "400", fontSize: "12px" }}>
            Max 7
          </Typography>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "12px",
              color: theme.palette.primary.main,
              cursor: "pointer",
            }}
            onClick={() =>
              setSelectedColumn(
                columnArray
                  .slice(0, searchParams.get("s") || 6)
                  .filter((data) => data.id !== "number")
                  .map((headCell) => headCell.id)
              )
            }
          >
            Reset
          </Typography>
        </Box>
        <Divider sx={{ my: 0.5 }} />

        {columnArray
          .filter((data) => data.id !== "number")
          .map((headCell, index) => {
            const isItemSelected = isSelected(headCell.id);
            return (
              <MenuItem key={index}>
                <Checkbox
                  checked={isItemSelected}
                  onChange={() => handleSelectedColumn(headCell.id)}
                  inputProps={{ "aria-label": "controlled" }}
                  disabled={!isItemSelected && selectedColumn.length >= 7}
                />
                {headCell.title}
              </MenuItem>
            );
          })}
      </CustomMenu>
      <CustomButton
        startIcon={<ExitToAppIcon />}
        endIcon={<ArrowDropDownIcon />}
        onClick={(e) => {
          setOpenExport(e.currentTarget);
        }}
        aria-haspopup="true"
        sx={{
          boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
          bgcolor: "#FFFFFF",
          color: "#000000",
          fontSize: "0.875rem",
          "&:hover": {
            bgcolor: "#FFFFFF",
            color: "#000000",
            boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.1)",
          },
          px: 2,
          py: 0.8,
        }}
      >
        Export
      </CustomButton>
      <CustomMenu
        open={isOpenExport}
        openMenu={openExport}
        setOpenMenu={setOpenExport}
        PaperProps={{ sx: { minWidth: "121px" } }}
      >
        <MenuItem
          onClick={() => {
            setOpenExport(null);
            downloadPdf();
          }}
          sx={{ color: "#000000" }}
        >
          PDF
        </MenuItem>
        <MenuItem>
          <ExportXlsExcel
            sx={{ color: "#000000" }}
            fileName="Master Hub Excel"
            excelData={hubsToExport}
          />
        </MenuItem>
        <CSVLink
          style={{ color: "#000000", textDecoration: "none" }}
          data={hubsToExport}
        >
          <MenuItem onClick={() => setOpenExport(null)}>CSV</MenuItem>
        </CSVLink>
      </CustomMenu>
      <CustomButton
        sx={{
          boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
          bgcolor: "#FFFFFF",
          color: "#000000",
          fontSize: "0.875rem",
          "&:hover": {
            bgcolor: "#FFFFFF",
            color: "#000000",
            boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.1)",
          },
          px: 2,
          py: 0.8,
        }}
        startIcon={<FilterAltIcon />}
        onClick={() => setIsOpenDialogFilter(true)}
      >
        Filter
      </CustomButton>
      <DialogFilter
        isOpenDialogFilter={isOpenDialogFilter}
        setIsOpenDialogFilter={setIsOpenDialogFilter}
        autocompleteFilter={autocompleteFilter}
        setAutocompleteFilter={setAutocompleteFilter}
        allData={allData}
        subsidiaryDatas={subsidiaryDatas}
        setSubsidiaryFilterValue={setSubsidiaryFilterValue}
        subsidiaryFilterValue={subsidiaryFilterValue}
        setFilterSubsidiaryArray={setFilterSubsidiaryArray}
        handleSaveFilter={handleSaveFilter}
        handleResetFilter={handleResetFilter}
      />
    </Box>
  );

  return (
    <CustomTable
      rowPerPage={rowPerPageTable}
      handleRowPerPage={(event) => {
        setRowPerPageTable(event.target.value);
        setCurrentPageTable(1);
      }}
      rowPerPageValues={rowPerPageValues}
      currentPage={currentPageTable}
      totalValueItems={totalTableItems}
      handleInputCurrentPage={(event) => {
        if (
          event.target.value >= Math.ceil(totalTableItems / rowPerPageTable)
        ) {
          setCurrentPageTable(Math.ceil(totalTableItems / rowPerPageTable));
        } else if (event.target.value <= 1) {
          setCurrentPageTable(1);
        } else {
          setCurrentPageTable(event.target.value);
        }
      }}
      handleBackArrow={() =>
        setCurrentPageTable(
          currentPageTable <= 1 ? currentPageTable : currentPageTable - 1
        )
      }
      handleForwardArrow={() =>
        setCurrentPageTable(
          currentPageTable >= Math.ceil(totalTableItems / rowPerPageTable)
            ? currentPageTable
            : currentPageTable + 1
        )
      }
      name="Master List"
      toolbar={toolbar}
      isLoadingTable={isLoadingMasterHub}
      searchValue={masterHubKeyword}
      setSearchValue={setMasterHubKeyword}
      isNoData={!isLoadingMasterHub && hubsData.length === 0 ? true : false}
      noDataText="No Data Found"
      isLoadingMasterHub={isLoadingMasterHub}
    >
      <TableHead>
        <TableRow sx={{ bgcolor: "#FAFAFA" }}>
          {columnArray
            .filter((value) => selectedColumn.includes(value.id))
            .map((headCell, idx) => (
              <CustomTableCells
                sx={{
                  ":last-child": {
                    pr: 0.5,
                  },
                  color: headCell.color ? headCell.color : "#000000",
                  fontWeight: 500,
                }}
                key={idx}
                align={headCell.numeric ? "right" : "left"}
                padding={headCell.disablePadding ? "none" : "normal"}
              >
                {headCell.icon === true ? (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setSortTableMasterHub(headCell.sortName);
                      setIsSortAscMasterHub(!isSortAscMasterHub);
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "0.75rem",
                      }}
                    >
                      {headCell.title}
                    </Typography>
                    {sortTableMasterHub === headCell.sortName ? (
                      isSortAscMasterHub ? (
                        <ArrowRightAltIcon
                          sx={{
                            fontSize: "12px",
                            transform: "rotate(90deg)",
                            color: theme.palette.primary.main,
                          }}
                        />
                      ) : (
                        <ArrowRightAltIcon
                          sx={{
                            fontSize: "12px",
                            transform: "rotate(270deg)",
                            color: theme.palette.primary.main,
                          }}
                        />
                      )
                    ) : (
                      <SyncAltIcon
                        sx={{
                          fontSize: "12px",
                          transform: "rotate(90deg)",
                          color: "#9E9D9D",
                        }}
                      />
                    )}
                  </Box>
                ) : (
                  headCell.title
                )}
              </CustomTableCells>
            ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {isLoadingMasterHub ? (
          <TableRow>
            <TableCell colSpan={selectedColumn?.length}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "74px",
                  gap: 2,
                }}
              >
                <CircularProgress size={24} />
                <Typography> Loading...</Typography>
              </Box>
            </TableCell>
          </TableRow>
        ) : (
          hubsData.map((dataTable, index) => {
            const {
              namaToko,
              gambar,
              idToko,
              subsidiaryId,
              subsidiary,
              picName,
              picPhone,
              SKU,
              COGS,
              alamat,
              coordinate,
            } = dataTable;
            return (
              <TableRow
                key={index}
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  setSubHubSelected(idToko);
                  updatedSearchParams.set("subhub-overview", idToko);
                  setSearchParams(updatedSearchParams);
                }}
              >
                <CustomTableCells>{index + 1}</CustomTableCells>

                {selectedColumn.includes("photo") && (
                  <Tooltip
                    followCursor
                    arrow
                    title="Click to see sub-hub list"
                    placement="bottom"
                  >
                    <CustomTableCells>
                      {gambar ? (
                        <Box
                          component="img"
                          src={
                            process.env.REACT_APP_API_IMAGE_BASE_URL +
                            "/" +
                            gambar.split(",")[0]
                          }
                          // src={''}
                          sx={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "8px",
                          }}
                        />
                      ) : (
                        <NoImage />
                      )}
                    </CustomTableCells>
                  </Tooltip>
                )}

                {selectedColumn.includes("name") && (
                  <Tooltip
                    followCursor
                    arrow
                    title="Click to see hub detail"
                    placement="bottom"
                  >
                    <CustomTableCells
                      onClick={(event) => {
                        setRowSelected(idToko);
                        // dispatch(changeMasterHub(idToko));
                        dispatch(
                          loadMasterHubPack({
                            subsidiary: subsidiary,
                            idSubsidiary: subsidiaryId,
                            masterHub: namaToko,
                            idMasterHub: idToko,
                          })
                        );
                        updatedSearchParams.set("detail", idToko);
                        setSearchParams(updatedSearchParams);

                        event.stopPropagation();
                      }}
                    >
                      {namaToko || "-"}
                    </CustomTableCells>
                  </Tooltip>
                )}

                {selectedColumn.includes("subsidiary") && (
                  <CustomTableCells>{subsidiary || "-"}</CustomTableCells>
                )}

                {selectedColumn.includes("pic") && (
                  <CustomTableCells>{picName || "-"}</CustomTableCells>
                )}

                {selectedColumn.includes("phoneNumber") && (
                  <CustomTableCells>{picPhone || "-"}</CustomTableCells>
                )}

                {selectedColumn.includes("sku") && (
                  <CustomTableCells>{SKU || "-"}</CustomTableCells>
                )}

                {selectedColumn.includes("cogs") && (
                  <CustomTableCells>{COGS || "-"}</CustomTableCells>
                )}

                {selectedColumn.includes("address") && (
                  <CustomTableCells>{alamat || "-"}</CustomTableCells>
                )}
              </TableRow>
            );
          })
        )}
      </TableBody>
      {/*         
        // <TableBody>
        //   {[...Array(rowPerPageTable)].map((_, x) => (
        //     <TableRow key={x}>
        //       {selectedColumn.map((_, i) => (
        //         <TableCell key={i}>-</TableCell>
        //       ))}
        //     </TableRow>
        //   ))}
        // </TableBody> */}
    </CustomTable>
  );
};

export default Table;
